import { render, staticRenderFns } from "./BackCall.vue?vue&type=template&id=358a52cd&scoped=true&"
import script from "./BackCall.vue?vue&type=script&lang=js&"
export * from "./BackCall.vue?vue&type=script&lang=js&"
import style0 from "./BackCall.vue?vue&type=style&index=0&id=358a52cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358a52cd",
  null
  
)

export default component.exports